export default {
    inputSettlingConfig: {
        default: {
            tabId: 3,
            zoomEnabled: true,
            legendLocation: 'w',
            padY: 1.3,
            tickStep: 0,
            numPlotTicks: 6,
            ticksAbove: 2,
            ticksBelow: 1
        },
        dc: {
            name: 'Dc',
            subtabId: 1,

            // volts tab
            volts: {
                tickStep: 0.001
            }
        },
        ac: {
            name: 'Sin',
            subtabId: 2,
            tooltipLocation: 'nw',

            volts: {
                tickStep: 0.25
            }
        },
        muxed: {
            name: 'Muxed',
            subtabId: 3,
            legendLocation: 'nw',
            tooltipLocation: 'se'
        }
    },

    noiseDistortionConfig: {
        thd: {
            tickIncrement: 10,
            requiredYPadding: 1.5,
            zoomFitAllowed: true,
            legendLocation: 'nw'
        },
        sinad: {
            tickIncrement: 10,
            requiredYPadding: 1.5,
            legendLocation: 'sw'
        },
        enob: {
            tickIncrement: 1,
            requiredYPadding: 0.4,
            legendLocation: 'sw'
        }
    },

    noiseDistortionGraphObjects: {
        driver: {
            translation: 'legend_labels.thd_noise_driver',
            color: 'noiseDriver',
            series: {
                linePattern: 'dashed'
            },
            graphLine: 'ampLine'
        },
        adc: {
            translation: 'legend_labels.thd_noise_adc',
            color: 'noiseAdc',
            series: {
                linePattern: 'dashed'
            },
            graphLine: 'adcLine'
        },
        system: {
            translation: 'legend_labels.thd_noise_system',
            color: 'noiseSystem',
            series: {
                lineWidth: 3
            },
            graphLine: 'systemLine'
        },
        signal: {
            translation: 'legend_labels.thd_noise_signal',
            color: 'noiseSignal',
            series: {
                lineWidth: 3
            },
            graphLine: 'frequencyLine'
        },
        source: {
            translation: 'legend_labels.thd_noise_source',
            color: 'noiseSource',
            series: {
                linePattern: 'dashed'
            },
            graphLine: 'sourceLine',
            required: 'showOptionalSourceSettings'
        }
    },

    defaults: {
        noise: {
            curve: {
                hd2: -888,
                secondInvAmp: -777,
                mirroredAmpCurve: -999
            }
        }
    }
}